// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-container[data-v-70ba5bdc]{line-height:0}.image-skeleton[data-v-70ba5bdc]{position:absolute}.center[data-v-70ba5bdc]{top:50%;transform:translateY(-50%)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
